import PasswordConfigComponent from '../Components/SystemConfiguration/PasswordConfigComponent';

function SystemConfigurationPasswordPage() {
  return <PasswordConfigComponent />;
}

export default SystemConfigurationPasswordPage;
